import React, { useEffect, useState, Component } from "react";
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import HomeSlider from "./HomeSlider";
import axios from 'axios';
import { Link } from "react-router-dom";
import config from "../includes/ConfigFile";
import Trending from "./categorySlider/Trending";
import Horror from "./categorySlider/Horror";
import Contemporary from "./categorySlider/Contemporary";
import Fantasy from "./categorySlider/Fantasy";
import Mythology from "./categorySlider/Mythology";
import RomanceDrama from "./categorySlider/RomanceDrama";
import SuspenseThriller from "./categorySlider/SuspenseThriller";

const Home = ({ company, selectedLanguage, setSelectedLanguage  }) => {
    //alert(selectedLanguage);
    const [showMore, setShowMore] = useState(false);

    const toggleContent = () => {
        setShowMore(!showMore);
    };

   
    //Show Category List


    const settingsCategory = {
        className: "center",
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 6,
        swipeToSlide: true,
        // style: {
        //     background: "#222", // Specify the background color here
        //     color: '#bada55',
        // },
        afterChange: function (index) {
            console.log(
                `Slider Changed to: ${index + 1}, background: #222; color: #bada55`
            );
        },
        responsive: [
            {
                breakpoint: 1024, // screen width <= 1024px
                settings: {
                    slidesToShow: 3,
                    centerPadding: "40px",
                },
            },
            {
                breakpoint: 600, // screen width <= 600px
                settings: {
                    slidesToShow: 1,
                    centerPadding: "20px",
                },
            },
        ],
    };

    // Get Dynamic Category code start
    const [categoryData, setCategoryData] = useState([]);
    //const [selectedLanguage, setSelectedLanguage] = useState({ id: 1, name: "English" });

    useEffect(() => {
        if (selectedLanguage && selectedLanguage.id) {
        axios.get(`${config.BASE_URL}/api/categories/${selectedLanguage.id}`)
            .then(response => {
             console.log('Fetched data:', response.data); // Log the fetched data
                setCategoryData(response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
        }
    }, [selectedLanguage]);
    // Get Dynamic Category code end

    //Show Category List
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{ company.company_title } | Home</title>
                <link rel="canonical" href="http://mysite.com/example" />
                <meta name="description" content="Helmet application" />
            </Helmet>

            <div className="container p-3">
                <section>
                    <div className="tw-mt-4 md:tw-mt-10">
                        <div className="tw-flex tw-flex-row">
                            
                            <div className="slider-container">
                                <Slider {...settingsCategory}>
                                    {categoryData.map((slide, index) => (
                                        <div key={index} className="slide homeCategory">
                                            <Link to={`/category/${slide.id}/${selectedLanguage.id}`} style={{color:'#fff',textDecoration:'none'}}>
                                            <img src={`${config.BASE_URL}/public/uploads/admin/category_image/${slide.category_image}`} alt={`Slide ${index + 1}`} />
                                            <div className="slide-content">
                                                <div className="title">
                                                    {slide.category_name}
                                                </div>
                                            </div>
                                            </Link>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Home Slider Section */}
                <section className="section-pad">
                    <HomeSlider />
                </section>
                {/* Home Slider Section */}
                    <Trending/>
                    <Horror/>
                    <RomanceDrama/>
                    <Contemporary/>
                    <Fantasy/>
                    <Mythology/>
                    <SuspenseThriller/>
            </div>
        </>
    );
};

export default Home;